module.exports = __webpack_public_path__ + "c44d0b768dca957dac7a7510210cb8d5.jpg";